import * as ActionTypes from "../actions/types";
import { parseForum } from "../constants/parse/forum";
import {
  mapForumDatum,
  mapForumTopicCommentDatum,
  mapForumTopicDatum,
} from "../constants/map/forum";

const INITIAL_STATE = {
  forumById: {},
  forumAllIds: [],
  forums: [],
  topics: [],
  topicId: {},
  comments: [],
  commentPage: 0,
  commentPager: [],
  commentMeta: [],
  loading: false,
  receiveStatus: true,
  form: {},
  topic_form: {
    subject: "",
  },
  topicFormModal: false,
  depth: 0,
  subscriberToTopic: null,
  searchCommentInTopicText: null,
  searchTopicsText: null,
};

function fetchForums(state) {
  state.loading = true;
}

function fetchForumsFailed(state) {
  state.loading = false;
  state.receiveStatus = false;
}

function setLoading(state) {
  state.loading = true;
}

function storeForums(state, action) {
  let forumsById = {};
  let allIds = [];
  const forums = [];
  const { data } = action.payload;
  data.forEach((datum) => {
    const parent =
      datum.relationships.parent.data.length > 0
        ? datum.relationships.parent.data[0].id
        : "virtual";

    const children = data
      .filter(
        (datum2) =>
          datum2.relationships.parent.data[0].id &&
          datum.id === datum2.relationships.parent.data[0].id
      )
      .map((datum2) => datum2.id);

    forumsById[datum.id] = {
      ...parseForum(state.forumById?.[datum.id]),
      ...mapForumDatum(datum, parent, children),
      parent,
      children,
    };
    allIds.push(datum.id);
  });
  state.forums = forums;
  state.forumById = forumsById;
  state.forumAllIds = allIds;
  state.loading = false;
  state.receiveStatus = true;
}

function storeForumTopicId(state, action) {
  const { data, included } = action.payload;
  const topic = mapForumTopicDatum(data, included);
  state.loading = false;
  state.topicId = topic;
  state.receiveStatus = true;
}

function clearForumTopic(state) {
  state.topicId = {};
  state.comments = [];
  state.commentPager = [];
  state.commentMeta = [];
}

function storeForumTopics(state, action) {
  const topics = [];
  if (!action.payload) {
    state.loading = false;
    state.topics = [];
    state.receiveStatus = true;
    return;
  }
  const { data, included } = action.payload;
  data.forEach((datum) => topics.push(mapForumTopicDatum(datum, included)));
  state.loading = false;
  state.topics = topics;
  state.receiveStatus = true;
}

function storeForumTopicsFromSearch(state, action) {
  const searchTopicsText = state.searchTopicsText;
  if (searchTopicsText === "") {
    return;
  }
  storeForumTopics(state, action);
}

function clearForumTopics(state) {
  state.topics = [];
}

function storeForumTopicComments(state, action) {
  const comments = [];
  const { data, included, meta, links } = action.payload;
  data.forEach((datum) =>
    comments.push(mapForumTopicCommentDatum(datum, included))
  );
  state.loading = false;
  state.comments = comments;
  state.commentPager = links;
  state.commentMeta = meta;
  state.receiveStatus = true;
}

function saveForumCommentSucceed(state, action) {
  const { data, included } = action.payload;
  const comment = mapForumTopicCommentDatum(data, included);

  state.form = {};
  state.comments.push(comment);
  // state.commentPage = lastPage;
  state.loading = false;
  state.receiveStatus = true;
}

function updateCommentForumField(state, action) {
  if (!state.form) state.form = {};
  state.form[action.payload.name] = action.payload.value;
}

function updateForumTopicFormField(state, action) {
  if (!state.topic_form) state.topic_form = {};
  state.topic_form[action.payload.name] = action.payload.value;
}

function updateField(state, action) {
  state[action.payload.name] = action.payload.value;
}

function createForumTopicSuccess(state) {
  state.loading = false;
  state.receiveStatus = true;
}

function createForumTopicFailed(state) {
  state.loading = false;
  state.receiveStatus = false;
}

function changeSubscriptionStatus(state) {
  state.loading = false;
}

function fetchSubscriptionStatus(state) {
  state.subscriberToTopic = null;
}

function changeSubscriptionStatusSuccess(state, action) {
  const { type, subscribed } = action.payload;

  if (type === "forum") {
    state.subscriberToTopic = subscribed;
    return;
  }

  if (subscribed && subscribed.length > 0) {
    subscribed.forEach((datum) => {
      if (type === "forums") {
        if (!state.forumById) state.forumById = {};
        if (!state.forumById[datum.uuid]) state.forumById[datum.uuid] = {};
        state.forumById[datum.uuid].subscribed = datum.subscribed;
      }
    });
  } else {
    if (type === "forums" && action.payload.subscribed !== undefined) {
      if (!state.forumById) state.forumById = {};
      if (!state.forumById[action.payload.uuid])
        state.forumById[action.payload.uuid] = {};
      state.forumById[action.payload.uuid].subscribed =
        action.payload.subscribed;
    }
  }
}

function changeSubscriptionStatusFailed(state) {
  // No changes needed
}
function searchCommentInTopic(state, action) {
  const { searchComment } = action.payload;
  state.searchCommentInTopicText = searchComment;
}

function searchForumsAndTopics(state, action) {
  const { searchTopicsText } = action.payload;
  state.searchTopicsText = searchTopicsText;
  state.loading = true;
}

function clearForumsSearchText(state) {
  state.searchTopicsText = null;
}

export const forum = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.FETCH_FORUMS]: fetchForums,
    [ActionTypes.FETCH_FORUMS_FAILED]: fetchForumsFailed,
    [ActionTypes.STORE_FORUMS]: storeForums,

    [ActionTypes.FETCH_FORUM_TOPICS]: setLoading,
    [ActionTypes.FETCH_FORUM_TOPICS_FAILED]: fetchForumsFailed,
    [ActionTypes.STORE_FORUM_TOPICS]: storeForumTopics,
    [ActionTypes.CLEAR_FORUM_TOPICS]: clearForumTopics,

    [ActionTypes.FETCH_FORUM_TOPIC_ID]: setLoading,
    [ActionTypes.FETCH_FORUM_TOPIC_ID_FAILED]: fetchForumsFailed,
    [ActionTypes.STORE_FORUM_TOPIC_ID]: storeForumTopicId,

    [ActionTypes.CREATE_FORUM_TOPIC]: setLoading,
    [ActionTypes.CREATE_FORUM_TOPIC_SUCCESS]: createForumTopicSuccess,
    [ActionTypes.CREATE_FORUM_TOPIC_FAILED]: createForumTopicFailed,

    [ActionTypes.FETCH_FORUM_TOPIC_COMMENTS]: setLoading,
    [ActionTypes.FETCH_FORUM_TOPIC_COMMENTS_FAILED]: fetchForumsFailed,
    [ActionTypes.STORE_FORUM_TOPIC_COMMENTS]: storeForumTopicComments,
    [ActionTypes.UPDATE_FORUM_COMMENT_FIELD]: updateCommentForumField,

    [ActionTypes.SAVE_FORUM_COMMENT]: setLoading,
    [ActionTypes.SAVE_FORUM_COMMENT_FAILED]: fetchForumsFailed,
    [ActionTypes.SAVE_FORUM_COMMENT_SUCCEED]: saveForumCommentSucceed,
    [ActionTypes.UPDATE_FORUM_TOPIC_FORM_FIELD]: updateForumTopicFormField,

    [ActionTypes.UPDATE_FORUM_FIELD]: updateField,

    [ActionTypes.CHANGE_SUBSCRIPTION_STATUS]: changeSubscriptionStatus,
    [ActionTypes.CHANGE_SUBSCRIPTION_STATUS_SUCCESS]:
      changeSubscriptionStatusSuccess,
    [ActionTypes.CHANGE_SUBSCRIPTION_STATUS_FAILED]:
      changeSubscriptionStatusFailed,

    [ActionTypes.FETCH_SUBSCRIPTION_STATUS]: fetchSubscriptionStatus,
    [ActionTypes.SEARCH_COMMENT_IN_TOPIC]: searchCommentInTopic,
    [ActionTypes.SEARCH_FORUMS_AND_TOPICS]: searchForumsAndTopics,
    [ActionTypes.CLEAR_FORUM_TOPIC]: clearForumTopic,
    [ActionTypes.STORE_FORUM_TOPICS_AFTER_SEARCH]: storeForumTopicsFromSearch,
    [ActionTypes.CLEAR_FORUM_SEARCH_TEXT]: clearForumsSearchText,
  },
};
